import React from 'react'
import AyudaExportar from './ayuda-exportar'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'
import { formatMonto } from '../../common/dashboard-utils'

/**
 * Monto Pagado y Emitido por compañía tercero — **V1.1 (RG-541, 04-09-2026)**.
 * 🔴 Cambió la fuente y la clave: los montos ahora salen de `verifica_egreso_pago` y el campo pasó
 *    de `montoPagoTotal` a **`montoTotal`**. El tooltip suma la cantidad de egresos.
 */

// Resalta la franja de la compañía bajo el mouse: indica dónde se puede hacer clic.
const CURSOR_FILA = { fill: 'rgba(29, 111, 66, 0.12)' }

// El eje se abrevia a K/M: los montos completos no caben en las marcas.
const formatEje = (v) => {
    if (v >= 1000000) return `$${(v / 1000000).toFixed(0)}M`
    if (v >= 1000) return `$${(v / 1000).toFixed(0)}K`
    return `$${v}`
}

const TooltipMonto = ({ active, payload }) => {
    if (!active || !payload?.length) return null
    const dato = payload[0].payload
    return (
        <div style={{ background: '#fff', border: '1px solid #dee2e6', borderRadius: 6, padding: '8px 12px', fontSize: 12 }}>
            <div style={{ fontWeight: 600, marginBottom: 4 }}>{dato.compania}</div>
            <div>Monto pagado: <strong>{formatMonto(dato.montoTotal || 0)}</strong></div>
            <div style={{ color: '#6c757d', marginTop: 2 }}>Cantidad: {dato.cantidad}</div>
        </div>
    )
}

// Con `onExportar(entry)`, cada barra descarga los casos pagados de esa compañía (RG-602).
const MontosPorCiaBarras = ({ data = [], onExportar }) => {
    if (!data.length) return <div className='text-center text-muted py-5'>Sin datos</div>

    const top10 = [...data].sort((a, b) => b.montoTotal - a.montoTotal).slice(0, 10)

    // Una barra de monto bajo es casi invisible al lado de la mayor: toda la franja de la compañía es
    // clicable. Un clic justo sobre la barra lo atiende antes su `onClick` (el hook ignora la 2.ª llamada).
    const alClicFila = (estado) => {
        const fila = estado?.activePayload?.[0]?.payload
        if (onExportar && fila) onExportar(fila)
    }

    return (
        <div>
            {onExportar && (
                <AyudaExportar texto='Clic en una barra, o junto a ella, para descargar sus casos en Excel' />
            )}
            <ResponsiveContainer width='100%' height={280}>
                <BarChart
                    data={top10}
                    layout='vertical'
                    margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                    onClick={alClicFila}
                    style={{ cursor: onExportar ? 'pointer' : undefined }}
                >
                    <CartesianGrid strokeDasharray='3 3' horizontal={false} />
                    <XAxis type='number' tickFormatter={formatEje} tick={{ fontSize: 11 }} />
                    <YAxis type='category' dataKey='compania' tick={{ fontSize: 11 }} width={80} />
                    <Tooltip content={<TooltipMonto />} cursor={onExportar ? CURSOR_FILA : undefined} />
                    <Bar
                        dataKey='montoTotal'
                        fill='#4F517A'
                        radius={[0, 3, 3, 0]}
                        cursor={onExportar ? 'pointer' : undefined}
                        onClick={(barra) => onExportar && onExportar(barra?.payload ?? barra)}
                    />
                </BarChart>
            </ResponsiveContainer>
        </div>
    )
}

export default MontosPorCiaBarras
